import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'query-string'

import { MODALS } from '../constants'
import { getModalLocation } from '../lib/modal'
import { useIsAuthenticated } from './use-is-authenticated'

/**
 * Hook to handles detail page URLs with the `?add` query parameter.
 * It automatically opens the add-to-list modal so the user can choose one or more watchlists.
 * @param {Object} contentItem - The content item to be updated to the list.
 */
export const useAddToMyListQS = (contentItem) => {
  const history = useHistory()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    const search = qs.parse(location.search)
    const add = search.add

    if (!(isAuthenticated && typeof add !== 'undefined' && contentItem?.id)) {
      return
    }

    const restSearch = { ...search }
    delete restSearch.add

    history.replace(getModalLocation(
      {
        ...location,
        search: qs.stringify(restSearch)
      },
      MODALS.qsParams.addContentToLists,
      {
        contentItemId: contentItem.id
      },
      {
        contentItem
      }
    ))
  }, [contentItem, history, isAuthenticated, location])
}
